import { gql } from '@apollo/client'

export type DecisionStatusOpenActionRequestInput = {
  input: {
    dealId: number
    regionCode: string
    busGroupCode: string
    userEmail: string
  }
}

export type PendingActions = {
  requestedEmployeeEmail: string
  reasonCode: string
  reasonDescription: string
  closeReasonCode: string
  isCurrentUser: boolean
  redirectToUrl: string
  decisionActionType: string
  approvalFlowLevel: number
}

export type DecisionStatusOpenActionResponse = {
  decisionStatusOpenAction: {
    pendingAction: PendingActions[]
    didError: boolean
    errorMessage: string
  }
}

export const GET_DEAL_PENDING_ACTION = gql`
  query decisionStatusOpenAction($input: DecisionStatusOpenActionRequestInput) {
    decisionStatusOpenAction(request: $input) {
      pendingAction {
        requestedEmployeeEmail
        reasonCode
        reasonDescription
        closeReasonCode
        isCurrentUser
        redirectToUrl
        decisionActionType
        approvalFlowLevel
      }
      didError
      errorMessage
    }
  }
`
